import React from 'react';
import SecureSessionService from '../../services/session/SecureSessionService';
import { ORIGINAL_CLIENT_REDIRECT_URL } from '../../config';
import { useFlow } from '../../contexts/FlowContext';
import { getLogoutRedirectUrl } from '../../utils/nativeApp';

interface AccountLockedModalProps {
  isOpen: boolean;
  onClose?: () => void;
  supportPhone?: string;
  supportHours?: string;
}

const AccountLockedModal: React.FC<AccountLockedModalProps> = ({
  isOpen,
  onClose,
  supportPhone = '1-844-430-0335',
  supportHours = 'Monday - Friday, 8 a.m. to 8 p.m. ET'
}) => {
  const { resetFlow, getFlowData } = useFlow();
  const isNativeApp = getFlowData('device') === 'native_app';

  if (!isOpen) return null;

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    resetFlow();
    SecureSessionService.clearSession();
    const redirectUrl = isNativeApp
      ? getLogoutRedirectUrl()
      : ORIGINAL_CLIENT_REDIRECT_URL;
    console.log('[AccountLockedModal] Redirecting to:', redirectUrl);
    window.location.replace(redirectUrl);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content account-locked-modal-content">
        <h2 className="modal-title account-locked-modal-title">
          Your account is currently locked for security reasons.
        </h2>
        <div className="account-locked-modal-message">
          <p className="modal-message">
            To regain access, please contact our Technical Support team so they can verify your information and unlock your account.
            They can be reached at <a href={`tel:${supportPhone}`} className="mfa-contact-phone-link">{supportPhone}</a> (TTY: 711), {supportHours}.
          </p>
        </div>
        <div className="modal-actions account-locked-modal-actions">
          <button 
            onClick={handleClose}
            className="modal-btn-cancel account-locked-modal-button"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountLockedModal;
